import React from 'react';

import { AssigneeAvatarWithSelection } from 'components/common/AssigneeAvatarWithSelection/AssigneeAvatarWithSelection';

import { IAssignee } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/battlecards.types';
import { useAssigneeCellLogic } from 'components/widgets/RiskRegister/components/AssigneeCell/AssigneeCell.logic';
import { useAssigneeCellProvider } from 'components/widgets/RiskRegister/components/AssigneeCell/AssigneeCell.provider';

interface Props {
    assignee: IAssignee;
    riskId: number;
}
export const AssigneeCell = ({ assignee, riskId }: Props) => {
    const { api } = useAssigneeCellProvider();
    const { logic } = useAssigneeCellLogic({ api, riskId });

    return <AssigneeAvatarWithSelection assignee={assignee} handleSelection={logic.updateAssignee} classname={''} />;
};
